import { Link } from "react-router-dom"
import Seo from "@/components/Seo"

const PLANS = [
  {
    name: "DIY Website Builder",
    price: "$99",
    cadence: "taxes not included",
    tagline: "Build it yourself. We host and guide.",
    features: [
      "Guided website-building workflow",
      "Modern responsive templates",
      "Your own domain connection",
      "Email and chat guidance",
      "Basic SEO setup included",
    ],
  },
  {
    name: "Done-For-You Website",
    price: "$299+",
    cadence: "project based",
    tagline: "We design and build it professionally.",
    features: [
      "Custom professional design",
      "Up to 8 pages with shop option",
      "Local search optimization",
      "Forms, chatbot, and analytics",
      "Priority support and maintenance",
    ],
  },
]

export default function Websites() {
  return (
    <div>
      <Seo title="Website Design & Online Shops in Uganda | Jero-One" description="Professional website design, e-commerce shops and hosting for businesses in Uganda and North America. Build your website with Jero-One Technologies." path="/websites" />
      <section className="relative min-h-[62vh] overflow-hidden bg-brand-navy">
        <img fetchPriority="high"
          src="/website-assets/images/photo-1689236673934-66f8e9d9279b-1600x1000.jpg"
          alt="Modern website development workspace"
          className="absolute inset-0 h-full w-full object-cover opacity-25"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-brand-navy via-brand-navy/90 to-transparent" />
        <div className="relative mx-auto flex min-h-[62vh] max-w-7xl flex-col justify-center px-8 py-20 md:px-14">
          <div className="mb-4 font-mono text-xs tracking-widest text-brand-green-light">
            WEB & E-COMMERCE SOLUTIONS
          </div>
          <h1 className="max-w-4xl font-display text-6xl font-black leading-none text-brand-light md:text-7xl">
            YOUR BUSINESS
            <br />
            <span className="text-brand-green-light">
              DESERVES A BETTER WEBSITE.
            </span>
          </h1>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-brand-muted">
            Launch a responsive, search-ready website or online shop—with
            hosting, domains, analytics, security, and ongoing support available
            from one team.
          </p>
        </div>
      </section>

      <section className="bg-[#0A0F0B] px-6 py-20 md:px-14">
        <div className="mx-auto max-w-6xl">
          <div className="mb-12 text-center">
            <div className="mb-3 font-mono text-xs tracking-widest text-brand-green-light">
              CHOOSE YOUR PATH
            </div>
            <h2 className="font-display text-5xl font-black text-brand-light">
              FROM IDEA TO LAUNCH
            </h2>
          </div>
          <div className="grid gap-6 md:grid-cols-2">
            {PLANS.map((plan, index) => (
              <article
                key={plan.name}
                className={`rounded-2xl border p-8 md:p-10 ${
                  index === 1
                    ? "border-brand-green bg-brand-green/10"
                    : "border-brand-green/15 bg-brand-mid"
                }`}
              >
                <div className="text-xs font-bold uppercase tracking-widest text-brand-green-light">
                  {plan.tagline}
                </div>
                <h3 className="mt-4 font-display text-4xl font-black text-brand-light">
                  {plan.name}
                </h3>
                <div className="mt-6 flex items-end gap-2">
                  <span className="font-display text-5xl font-black text-brand-light">
                    {plan.price}
                  </span>
                  <span className="pb-2 text-sm text-brand-muted">
                    {plan.cadence}
                  </span>
                </div>
                <ul className="mt-8 space-y-3">
                  {plan.features.map((feature) => (
                    <li
                      key={feature}
                      className="flex gap-3 text-sm text-brand-light/80"
                    >
                      <span className="font-bold text-brand-green-light">
                        ✓
                      </span>
                      {feature}
                    </li>
                  ))}
                </ul>
                <Link
                  to="/contact"
                  className="mt-9 inline-block rounded-xl bg-brand-green px-7 py-3.5 text-sm font-bold text-brand-light transition-colors hover:bg-brand-green-light"
                >
                  {index === 0 ? "Start your website" : "Request a build"}
                </Link>
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-brand-mid px-6 py-20 md:px-14">
        <div className="mx-auto max-w-7xl">
          <div className="grid gap-10 lg:grid-cols-[0.8fr_1.2fr]">
            <div>
              <div className="mb-3 font-mono text-xs tracking-widest text-brand-green-light">
                FULL-SERVICE DIGITAL DELIVERY
              </div>
              <h2 className="font-display text-5xl font-black leading-none text-brand-light">
                MORE THAN A WEBSITE
              </h2>
            </div>
            <div className="grid gap-px overflow-hidden rounded-2xl bg-brand-green/15 sm:grid-cols-2">
              {[
                "Domain registration & business email",
                "Secure hosting & SSL",
                "Online shops & payment integration",
                "Search engine optimization",
                "Analytics & conversion tracking",
                "Maintenance & content updates",
                "Custom software integrations",
                "Branding & responsive design",
              ].map((feature) => (
                <div
                  key={feature}
                  className="bg-[#0A0F0B] p-6 text-sm font-semibold text-brand-light"
                >
                  {feature}
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <section className="bg-brand-green px-6 py-16 md:px-14">
        <div className="mx-auto max-w-4xl text-center">
          <h2 className="font-display text-5xl font-black text-brand-light">
            LET’S BUILD YOUR DIGITAL HOME
          </h2>
          <p className="mt-4 text-brand-light/70">
            Tell us what you sell, who you serve, and what success looks like.
          </p>
          <Link
            to="/contact"
            className="mt-8 inline-block rounded-xl bg-brand-light px-10 py-4 font-bold text-brand-green"
          >
            Discuss your website
          </Link>
        </div>
      </section>
    </div>
  )
}
